module.exports = __webpack_public_path__ + "img/amernewkf3.4c4a5da5.png";